import type { FeedResponseSection, FeedSection } from "@/features/feed/contract/sections"
import { STANDALONE_SECTION_TYPES } from "@/generated/feed-components"

export const SECTION_TYPES = [
  ...STANDALONE_SECTION_TYPES,
  "HERO_CAROUSEL",
  "HERO_PHOTO",
  "DROP_RAIL",
  "BENTO",
  "CATEGORY_COVER",
  "PRODUCT_CAROUSEL",
  "CATEGORY_GRID",
  "COLLECTION_LINKS",
  "PROMO_BANNER",
  "TRUST_BAND",
  "PAYMENT_TIMELINE",
  "TESTIMONIALS",
  "BRAND_SPOTLIGHT_BAND",
  "LOOK_ROW",
  "CTA_BAND",
  "PRODUCT_LIST_HANDOFF",
  "SPOTLIGHT",
  "GIFTS_BY_PRICE",
  "PAYMENT_PLAN",
  "SCALE_WALL",
  "FAQ_BAND",
] as const satisfies readonly FeedResponseSection["type"][]

export type KnownSectionType = (typeof SECTION_TYPES)[number]

// Retired 2026-08-02 (BRAND_STRIP added 2026-08-06). The backend enum still carries
// these, so they are listed here to stay unrenderable rather than merely absent: a
// page that still holds one skips it. Each was live on zero pages and either
// duplicated a better section (STORY_TRAY and CATEGORY_ICONS → CATEGORY_GRID,
// DEAL_CARD → SPOTLIGHT, PRODUCT_GRID → PRODUCT_CAROUSEL) or made its argument
// in a register the redesign rejects. BRAND_STRIP's marquee ran 6.5x the viewport
// width at 390, legible only a fragment at a time.
export const RESERVED_SECTION_TYPES = [
  "PRODUCT_GRID",
  "DEAL_CARD",
  "CATEGORY_ICONS",
  "STORY_TRAY",
  "ACTIVITY_TICKER",
  "BUNDLE",
  "APP_BAND",
  "BRAND_STRIP",
  "QUINCENA_HERO",
  "CINEMATIC_HERO",
] as const satisfies readonly FeedResponseSection["type"][]

export const isKnownSectionType = (type: string): type is KnownSectionType => (SECTION_TYPES as readonly string[]).includes(type)

export const isKnownSection = (section: FeedResponseSection): section is FeedSection => isKnownSectionType(section.type)

export type StandaloneSectionType = (typeof STANDALONE_SECTION_TYPES)[number]
export const isStandaloneSectionType = (type: string): type is StandaloneSectionType => (STANDALONE_SECTION_TYPES as readonly string[]).includes(type)
